import { render, staticRenderFns } from "./HeaderNovalisCircle.vue?vue&type=template&id=ab7acb16&"
import script from "./HeaderNovalisCircle.vue?vue&type=script&lang=js&"
export * from "./HeaderNovalisCircle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNovalisCircle.vue?vue&type=style&index=0&id=ab7acb16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports